import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import UIkit from 'uikit'
import { withRouter } from 'react-router-dom'
import SelectCountry from 'app/views/components/Forms/SelectCountry';

import { claimUserReward } from 'app/state/modules/rewards'
import Icon from 'app/views/components/Icon';

const GiftCard = (props) => {
  const { email } = props;
  const [country, setCountry] = useState('United States of America (the)');
  const [currentCard, setCurrentCard] = useState('');
  const [currentPage, setCurrentPage] = useState('select card');
  const availableCards = props.catalogByOrganizationId[props.match.params.organization_uuid].giftCard
  console.log({ availableCards })
  const cards = [
    {
      name: "Card1",
      imgSrc: "/static/images/Cards/Card1.png",
    },
    {
      name: "Card2",
      imgSrc: "/static/images/Cards/Card2.png",
    },
    {
      name: "Card3",
      imgSrc: "/static/images/Cards/Card3.png",
    },
    {
      name: "Card4",
      imgSrc: "/static/images/Cards/Card4.png",
    },
    {
      name: "Card5",
      imgSrc: "/static/images/Cards/Card5.png",
    },
    {
      name: "Card6",
      imgSrc: "/static/images/Cards/Card6.png",
    },
    {
      name: "Card7",
      imgSrc: "/static/images/Cards/Card7.png",
    },
    {
      name: "Card8",
      imgSrc: "/static/images/Cards/Card8.png",
    },
    {
      name: "Card9",
      imgSrc: "/static/images/Cards/Card9.png",
    },
    {
      name: "Card10",
      imgSrc: "/static/images/Cards/Card10.png",
    },
    {
      name: "Card11",
      imgSrc: "/static/images/Cards/Card11.png",
    },
    {
      name: "Card12",
      imgSrc: "/static/images/Cards/Card12.png",
    },
  ];

  const cardClicked = (card) => {
    currentCard === card ? setCurrentCard(null) : setCurrentCard(card);
  }

  const selectCard = () => {
    setCurrentPage('delivery');
  }

  const backToOption = () => {
    setCurrentPage('select card');
  }

  const DeliveryCard = currentCard;

  const SelectCard = () => {
    return (
      <div className="uk-margin-top">
        <p className="uk-text-emphasis uk-text-center">Gift Card Options</p>
        {/* <p className="sub_title">Country</p>
          <SelectCountry
            currentCountry={country}
            onCountryChange={currentCountry => {
              setCountry(currentCountry)
            }}
          /> */}
        {/* <p className="card_title">Select Card</p> */}
        <div
          className="uk-flex uk-flex-wrap uk-flex-row"
        >
          {availableCards.map(card => (
            <div
              className="uk-margin-small-left uk-margin-small-right uk-margin-small-top uk-margin-small-bottom"
              style={{
                boxShadow: (currentCard || {}).uuid === card.uuid ? '0 0 0 2pt #1e87f0' : undefined,
                width: 130,
                borderRadius: 5,
              }}
              onClick={() => cardClicked(card)}
              key={card.uuid}
            >
              <img src={card.giftCard.metadata.imageUrls["130w-326ppi"]} alt={card.name} width="100%" />
            </div>
          ))}
        </div>
        <div className="uk-flex uk-flex-right">
          <button
            className="uk-button uk-button-small uk-button-primary uk-margin-bottom"
            disabled={!currentCard}
            onClick={selectCard}
          >
            Select Card
          </button>
        </div>
      </div>
    )
  }

  const Delivery = () => {
    return (
      <>
        <div className="uk-flex uk-flex-row uk-width-1-1">
          <div className="uk-width-medium uk-flex uk-flex-column uk-flex-left uk-flex-bottom">
            <button
              className="uk-button uk-button-small uk-button-secondary uk-flex uk-flex-row uk-flex-between uk-flex-middle"
              style={{
                alignSelf: 'flex-start'
              }}
              href="#"
              onClick={backToOption}
            >
              <Icon name="arrow-left-s" className="uk-margin-small-right" />
              Back to Options
            </button>
            <br />
            <br />
            <img src={DeliveryCard.giftCard.metadata.imageUrls["200w-326ppi"]} alt={DeliveryCard.giftCard.name} />
          </div>
          <div className="uk-width-expand uk-padding uk-padding-remove-top uk-flex uk-flex-column uk-flex-top">
            <h3 className="uk-margin-remove">Delivery Information</h3>
            <p className="uk-text-emphasis">{DeliveryCard.giftCard.name}</p>
            <p>Amount <span className="uk-margin-large-left">{`${parseFloat(DeliveryCard.giftCard.amount.amount).toFixed(2)} ${DeliveryCard.giftCard.amount.currency}`}</span></p>
            <div className="uk-text-small uk-text-left" dangerouslySetInnerHTML={{ __html: DeliveryCard.giftCard.description }} />
            <button
              className="uk-button uk-button-primary uk-button-small"
              onClick={() => {
                props.claimUserReward(props.match.params.organization_uuid, DeliveryCard.uuid, DeliveryCard.giftCard.metadata, () => {
                  props.history.push('/plan/confirmation')
                }, 'You should receive your Gift Card very soon.')
              }}
              disabled={props.claimingReward}
            >
              {props.claimingReward ? <span> Claiming ... </span> : `Claim Reward`}
            </button>
            <br />
            <br />
            {Boolean(DeliveryCard.giftCard.metadata.brandRequirements.terms) && (
              <>
                <b>Terms</b>
                <div
                  className="uk-text-small"
                  dangerouslySetInnerHTML={{ __html: DeliveryCard.giftCard.metadata.brandRequirements.terms }}
                />
              </>
            )}
            <b>Disclaimer</b>
            <div
              className="uk-text-small"
              dangerouslySetInnerHTML={{ __html: DeliveryCard.giftCard.metadata.brandRequirements.disclaimer }}
            />
          </div>
        </div>
      </>
    )

    return (
      <div>

        <div className="">
          <div>


            <img src={DeliveryCard.giftCard.metadata.imageUrls["130w-326ppi"]} alt={DeliveryCard.giftCard.name} width="100%" />
          </div>
          <div className="details_section">
            <p className="uk-text-emphasis">{DeliveryCard.giftCard.name}</p>
            <div dangerouslySetInnerHTML={{ __html: DeliveryCard.giftCard.description }} />
            <div>
              <div>
                <a
                  className="uk-text-small"
                  onClick={() => {
                    UIkit.modal.alert(DeliveryCard.giftCard.metadata.brandRequirements.disclaimer)
                  }}
                >
                  View Disclaimer
                </a>
              </div>
              <br />
              <div>
                <p>
                  {`Amount: ${parseFloat(DeliveryCard.giftCard.amount.amount).toFixed(2)} ${DeliveryCard.giftCard.amount.currency}`}
                </p>
              </div>
            </div>
            <p className="email_desc">Email Address</p>
            <input
              className="uk-input uk-form-width-large"
              type="text"
              spellCheck={false}
              // onChange={emailChanged}
              value={email}
              disabled
            />
            <div className="uk-flex uk-flex-right uk-margin-top">

            </div>
          </div>
        </div>
      </div>
    )
  }

  if (currentPage !== 'select card') {
    return Delivery();
  }
  return SelectCard();
}

const mapStateToProps = (state) => ({
  // auth
  email: state.auth.user.email,
  user: state.hacker.currentHackerDetails,
  catalogByOrganizationId: state.rewards.catalogByOrganizationId,
  claimingReward: state.rewards.claimingReward,
})

export default withRouter(connect(mapStateToProps, {
  claimUserReward
})(GiftCard))
